import styled from "styled-components";
import { Box } from "styles/globalComponents";

export const TableItemStyle = styled.tr`
  .disabled {
    pointer-events: none;
    background-color: #ab92bf;
    color: white;
    border: transparent;
  }

  .loader {
    padding: 5px 24px;
  }

  button {
    width: auto;
    flex: 0 !important;

    &.status-button:hover {
      background-color: transparent;
      color: #572580;
    }
  }
`;

export const Form = styled.form`
  flex-wrap: wrap;
  .select-search {
    width: 135px;
    .field-holder .input {
      width: 135px !important;
    }
  }

  .input-type {
    width: 200px;
    .field-holder .input {
      width: 200px !important;
    }
  }

  .select-search-submit-types.client {
    width: 140px;
    .react-select {
      width: 140px;
    }
  }

  .dates {
    width: 250px !important;
  }
`;

export const ModalChangeStatusStyle = styled(Box)`
  max-height: calc(90vh - 120px);
  overflow-y: auto;

  .field-holder {
    width: 100%;
    max-width: 500px;
    label {
      font-family: var(--font-family);
      font-size: 14px;
      margin-bottom: 8px;
    }

    textarea {
      height: 100px;
      &::placeholder {
        font-family: var(--font-family);
        font-size: 14px;
        color: #999999;
      }
    }
  }

  .inline-schedule {
    margin-top: 12px;

    .available-months {
      margin-top: 16px;
    }

    .datetime-result-list {
      margin-top: 16px;
    }

    .dates-list {
      grid-template-columns: repeat(3, 1fr);
      max-width: 100%;
    }

    .text-md {
      font-size: 1rem;
    }
  }

  .schedule-error {
    color: #dc2626;
    font-size: 14px;
    text-align: center;
    margin: 0;
  }
`;

export const TableBody = styled.tbody`
  &.table-content {
    .item-width button {
      padding: 0 5px;
    }

    thead th,
    tbody td {
      padding: 9px 15px;
    }
  }
`;
